(() => {
  'use strict';
  if (!window.customElements || customElements.get('km-cart-pair-carousel')) return;

  class KMCartPairCarousel extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.km-cart-pair__list');
      this.previous = this.querySelector('[data-km-pair-page-prev]');
      this.next = this.querySelector('[data-km-pair-page-next]');
      this.onClick = event => {
        if (this.hasAttribute('data-km-pair-remote')) return;
        const previous = event.target.closest('[data-km-pair-page-prev]');
        const next = event.target.closest('[data-km-pair-page-next]');
        if (!previous && !next) return;
        event.preventDefault();
        this.setPage(this.page + (next ? 1 : -1), true);
      };
      this.addEventListener('click', this.onClick);
      this.updateCards();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.animation?.cancel();
    }

    updateCards() {
      if (this.hasAttribute('data-km-pair-remote')) return;
      this.cards = [...this.querySelectorAll('[data-km-cart-pair-product]')];
      this.pageCount = Math.ceil(this.cards.length / 3);
      this.setPage(0);
    }

    setPage(page, animate = false) {
      const nextPage = Math.max(0, Math.min(page, this.pageCount - 1));
      if (animate && nextPage === this.page) return;
      this.page = nextPage;
      this.cards.forEach((card, index) => { card.hidden = Math.floor(index / 3) !== this.page; });
      this.previous.disabled = this.page === 0;
      this.next.disabled = this.page >= this.pageCount - 1;
      this.querySelector('[data-km-pair-pagination]').hidden = this.pageCount <= 1;
      this.querySelector('[data-km-pair-page-status]').textContent = this.pageCount
        ? `Page ${this.page + 1} of ${this.pageCount}` : '';
      if (animate) window.KMCartAnalytics?.track('click_cart_recommendation_carousel');
      if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.animation?.cancel();
        this.animation = this.list.animate?.([{opacity: .4}, {opacity: 1}], {duration: 160});
      }
    }
  }

  customElements.define('km-cart-pair-carousel', KMCartPairCarousel);
})();
